<template>
    <div>
        <el-form size="mini">
            <el-row :gutter="20">
                <el-col :span="6">
                    <el-form-item :label="$t('reports.createdFrom')"
                                  prop="createdOnFrom">
                        <el-date-picker v-model="form.createdOnFrom"
                                        type="date"
                                        style="width:100%;"></el-date-picker>
                    </el-form-item>
                    <el-form-item :label="$t('reports.acceptedDateFrom')"
                                  prop="dateFrom">
                        <el-date-picker v-model="form.dateFrom"
                                        type="date"
                                        style="width:100%;"></el-date-picker>
                    </el-form-item>
                    <el-form-item :label="$t('common.claimNumber')"
                                  prop="claimNumber">
                        <el-input v-model="form.claimNumber"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('common.invoiceNumber')"
                                  prop="invoiceNumber">
                        <el-input v-model="form.invoiceNumber"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('common.serviceTicketNumber')"
                                  prop="serviceTicketNumber">
                        <el-input v-model="form.serviceTicketNumber"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('reports.customerChain')"
                                  prop="chainId">
                        <chain-selector v-model="form.chainId"></chain-selector>
                    </el-form-item>
                    <el-form-item :label="$t('common.customerName')"
                                  prop="customerName">
                        <el-input v-model="form.customerName"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('common.customerPhone')"
                                  prop="customerPhone">
                        <el-input v-model="form.customerPhone" v-mask="'(###) ###-####'"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('common.serialNumber')"
                                  prop="serialNumber">
                        <el-input v-model="form.serialNumber"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('common.serviceCoverage')"
                                  prop="serviceCoverage">
                        <service-coverage-selector v-model="form.serviceCoverage"></service-coverage-selector>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item :label="$t('reports.createdTo')"
                                  prop="createdOnTo">
                        <el-date-picker v-model="form.createdOnTo"
                                        type="date"
                                        style="width:100%;"></el-date-picker>
                    </el-form-item>
                    <el-form-item :label="$t('reports.acceptedDateTo')"
                                  prop="dateTo">
                        <el-date-picker v-model="form.dateTo"
                                        type="date"
                                        style="width:100%;"></el-date-picker>
                    </el-form-item>
                    <el-form-item :label="$t('common.status')"
                                  prop="status">
                        <el-select v-model="form.status"
                                   style="width:100%;">
                            <el-option label="" 
                                       value=""></el-option>
                            <el-option :label="$t('common.new')"
                                       value="1"></el-option>
                            <el-option :label="$t('common.acceptAndProcess')"
                                       value="2"></el-option>
                            <el-option :label="$t('common.moreinfoRequired')"
                                       value="3"></el-option>
                            <el-option :label="$t('common.rejected')"
                                       value="4"></el-option>
                            <el-option :label="$t('reports.modifiedStatus')"
                                       value="5"></el-option>
                            <el-option :label="$t('common.paid')"
                                       value="6"></el-option>
                            <el-option :label="$t('common.pendingReturnPart')"
                                       value="7"></el-option>
                            <el-option :label="$t('common.pendingRepairCodeCorrections')"
                                       value="8"></el-option>
                            <el-option :label="$t('common.correctedRepairCodes')"
                                       value="9"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('common.customerZip')"
                                  prop="customerZip">
                        <el-input v-model="form.customerZip"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('common.serviceCompany')"
                                  prop="serviceCompany">
                        <el-input v-model="form.serviceCompany"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('common.partNumber')"
                                  prop="partNumber">
                        <el-input v-model="form.partNumber"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('common.model')"
                                  prop="productId">
                        <product-selector v-model="form.productId"></product-selector>
                    </el-form-item>
                    <el-form-item :label="$t('common.category')"
                                  prop="categoryId">
                        <resolution-category-selector v-model="form.categoryId"
                                                      :productId="form.productId"></resolution-category-selector>
                    </el-form-item>
                    <el-form-item :label="$t('common.code')"
                                  prop="codeId">
                        <repair-code-selector v-model="form.codeId"
                                              :productId="form.productId"
                                              :categoryId="form.categoryId"></repair-code-selector>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-button :loading="loading"
                       type="primary"
                       @click="generateReport">{{$t('common.generate')}}</el-button>
            <el-button typeof="secondary" @click="clearFields">Clear</el-button>
            <p class="labelInfo">{{$t('reports.noDatesChoosenMessage')}}</p>
        </el-form>
    </div>
</template>

<script>
    import {
        ProductSelector,
        ServiceCoverageSelector,
        ResolutionCategorySelector,
        RepairCodeSelector
    } from "@/app/shared/components";
    import { ChainSelector } from "@/app/masters/customers/components";
    import api from "../api";

    export default {
        name: "sims-ap-report",
        components: {
            ChainSelector,
            ProductSelector,
            ServiceCoverageSelector,
            ResolutionCategorySelector,
            RepairCodeSelector
        },
        data() {
            return {
                form: {
                    fields: [],
                    categoryId: null,
                    codeId: null
                },
                loading: false
            };
        },
        watch: {
            "form.productId": function () {
                this.form.categoryId = null;
            },
            "form.categoryId": function () {
                this.form.codeId = null;
            }
        },
        methods: {
            generateReport() {
                console.log(this.form);
                this.loading = true;
                api.downloadSimsApReport(this.form).then(response => {
                    this.loading = false;
                    var blob = response.data;
                    var fileName = response.headers["content-disposition"]
                        .split(";")[1]
                        .split("=")[1];
                    fileName = fileName.replace(/"/g, '')
                    if (typeof window.navigator.msSaveBlob !== "undefined") {
                        window.navigator.msSaveBlob(blob, fileName);
                    } else {
                        var blobURL = window.URL.createObjectURL(blob);
                        var tempLink = document.createElement("a");
                        tempLink.style.display = "none";
                        tempLink.href = blobURL;
                        tempLink.setAttribute("download", fileName);

                        // Safari thinks _blank anchor are pop ups. We only want to set _blank
                        // target if the browser does not support the HTML5 download attribute.
                        // This allows you to download files in desktop safari if pop up blocking
                        // is enabled.
                        if (typeof tempLink.download === "undefined") {
                            tempLink.setAttribute("target", "_blank");
                        }

                        document.body.appendChild(tempLink);
                        tempLink.click();
                        document.body.removeChild(tempLink);
                        window.URL.revokeObjectURL(blobURL);
                    }
                });
            },
            clearFields() {
                this.form = {
                    fields: [],
                    categoryId: null,
                    codeId: null
                }
            }
        }
    };
</script>

<style scoped>
    .checkbox {
        width: 100%;
        margin-left: 0;
    }

    .fields {
        width: 570px;
        margin-bottom: 10px;
    }

    .labelInfo {
        font-size: smaller;
    }
</style>


// WEBPACK FOOTER //
// ClientApp/app/reports/components/ApReport.vue